import { render, staticRenderFns } from "./DT_LandingPage.vue?vue&type=template&id=5221473c&scoped=true&"
import script from "./DT_LandingPage.vue?vue&type=script&lang=js&"
export * from "./DT_LandingPage.vue?vue&type=script&lang=js&"
import style0 from "./Data_Tools.css?vue&type=style&index=0&id=5221473c&prod&scoped=true&lang=css&"
import style1 from "./DT_LandingPage.vue?vue&type=style&index=1&id=5221473c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5221473c",
  null
  
)

export default component.exports